import community from './community'
import login from './login'
import file from './file'

export default {
  ...community,
  ...login,
  ...file
}
